<script lang="ts" setup>
import { computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import ProgressSpinner from 'primevue/progressspinner';
import { useAuthStore } from '@/stores/authStore';
import { useRouter, useRoute } from 'vue-router';
import { LOGIN_ROUTER_PAGE } from '@/utils/consts';

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()
const { loading } = storeToRefs(authStore)

onMounted(async () => {
  if (route.meta.private == true) {
    await authStore.check()
    if (!authStore.authorized) {
      router.push(LOGIN_ROUTER_PAGE)
      return
    }
  }
})

const isSomeLoading = computed(() => loading.value.check || loading.value.auth)
</script>

<template>
  <div v-if="isSomeLoading" class="w-full h-screen flex justify-center items-center align-center" key="spinner">
    <ProgressSpinner>
    </ProgressSpinner>
  </div>
  <div v-show="!isSomeLoading" key="content">
    <slot />
  </div>
</template>
